import { todayNYearsAgo } from '@bingads-webui-universal/primitive-utilities';

import * as segmentationType from './segmentation-type';

const diffDay = (start, end) => Math.round((end - start) / 86400000);

export function isTimeRangeValid(segmentType, {
  start = null,
  end = null,
  compared = {},
} = {}) {
  const { start: comparedStart, end: comparedEnd } = compared || {};
  // The first date that BI has segmentation data, offset by 1 day to ensure no timezone issues.
  const goalSegmentStartDate = new Date('October 26, 2017 00:00:00');
  // The first date that BI has segmentation data, offset by 1 day to ensure no timezone issues.
  const audienceSegmentStartDate = new Date('January 05, 2018 00:00:00');

  // If time range control didn't initialize successfully, we will just pass data directly to MT
  if (!start || !end) {
    return true;
  }

  let totalRange = diffDay(start, end);

  if (comparedStart && comparedEnd) {
    totalRange += diffDay(comparedStart, comparedEnd);
  }

  const oneYearAgo = todayNYearsAgo(end, 1);
  const threeYearsAgo = todayNYearsAgo(end, 3);
  const withinThreeYears = start >= threeYearsAgo;
  const moreThanOneYear = oneYearAgo >= start;

  switch (segmentType) {
    case segmentationType.Day:
      return totalRange < 16;
    case segmentationType.Week:
      return totalRange >= 7 && totalRange < 16 * 7;
    case segmentationType.Month:
      return totalRange >= 30 && totalRange < 16 * 30;
    case segmentationType.Quarter:
      return totalRange > 90 && withinThreeYears;
    case segmentationType.Year:
      return moreThanOneYear && withinThreeYears;
    case segmentationType.HourOfTheDay:
    case segmentationType.HourOfDay:
      // HourOfDay supports any range in recent 30 days
      // based on time zone, it could be 31 days difference
      return diffDay(start, new Date()) <= 31;
    case segmentationType.GoalName:
    case segmentationType.GoalType:
    case segmentationType.GoalCategory:
      return start >= goalSegmentStartDate;
    case segmentationType.AudienceName:
    case segmentationType.AudienceType:
      return start >= audienceSegmentStartDate;
    default:
      return true;
  }
}
